import { Voucher } from '../../../api/vouchers/types';
// import { PaymentMethodTypes, paymentMethodTypeEnum } from '../../../api/vouchers/helpers';

export type Currency = {
    _id: string;
    name: string;
    symbol: string;
};
// export { PaymentMethodTypes };
// export type PaymentMethodTypes = 'Credit Card' | 'Cash' | 'Check' | 'Bank Transfer' | 'Voucher';
// export const PaymentMethodTypesEnum = paymentMethodTypeEnum;
// export enum PaymentMethodTypesEnum {
//     CREDIT_CARD = 'Credit Card',
//     CASH = 'Cash',
//     CHECK = 'Check',
//     BANK_TRANSFER = 'Bank Transfer',
//     VOUCHER = 'Voucher'
// }

export const getRef = (voucher: Voucher) => {
    if (voucher.info?.supplierInvoice?.number) return `S: ${voucher.info?.supplierInvoice.number}`;
    else if (voucher.info?.reservationNumber) return `P: ${voucher.info.reservationNumber}`;
    else if (voucher.info?.referenceNumber) return `R: ${voucher.info.referenceNumber}`;
    else return '';
};
